import { atom } from 'jotai'
import { IFetchOfferGroup } from '../types'

type IOfferGroupsState = Array<IFetchOfferGroup> | null

const defaultState: IOfferGroupsState = null

// base atom with initial value
export const offerGroupsAtom = atom<IOfferGroupsState>(defaultState)